<template>
  <v-container>
    <div class="page-title">{{$route.name}}</div>
    <contents-layout v-if="reportsData">
      <template #title>
        <c-btn
            class="mt-3 ml-5"
            color="blue"
            outlined
            @click="downloadDataDialog = true"
            :loading="loading"
            :disabled="loading"
        >이용 통계 다운로드</c-btn>
      </template>
        <template #control>
          <v-menu
              v-model="startMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width: 250px; margin-right: 15px">
                <v-row>
                  <v-text-field
                      v-model="searchDateRangeDisplay"
                      label="시작일 ~ 종료일"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :disabled="loading"
                  ></v-text-field>
                </v-row>
              </div>
            </template>
            <c-date-range-picker
                v-model="searchDates"
                firstDayOfWeek="1"
                :pickerDate="searchDates[0]"
                locale="ko-kr"
                @input="startMenu = false"
            ></c-date-range-picker>
          </v-menu>
          <v-menu
              v-model="tableMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width: 200px">
                <v-select
                    v-model="tableMode"
                    :items="tables"
                    item-text="name"
                    item-value="no"
                    menu-props="{ offsetY: true}"
                    prepend-icon="library_books"
                    hide-details
                    label="업무일지 종류"
                    color="navy"
                ></v-select>
              </div>
            </template>
          </v-menu>
          <c-btn
              class="mt-3 ml-5"
              color="blue"
              outlined
              @click="downloadExcelDialog = true"
              :loading="loading"
              :disabled="loading"
          >업무일지 다운로드</c-btn>
          <v-text-field
              v-model="keyword"
              label="차량번호, 기사이름"
              single-line
              hide-details
              maxlength="32"
              class="ml-5"
              @keydown.enter="getDataByKeyword"
              min-width="490px"
          ></v-text-field>
          <v-btn color="blue" class="mt-4 mx-2" @click="getDataByKeyword"><span class="white--text">조회</span></v-btn>
        </template>
      <template #content>
        <v-card outlined class="pa-5">
          <v-row>
            <v-col cols="12">
              <div class="page-title font-weight-bold">차량 운행 통계</div>
            </v-col>
            <v-col cols="12">
              <v-card outlined class="pa-3">
                <v-row>
                  <v-col>
                    <span>주행 건수</span>
                  </v-col>
                  <v-col>
                    <span class="font-weight-bold">{{ reportsData ? $func.numberFormatter(reportsData.drivings) : 0 }} 건</span>
                  </v-col>
                  <v-col>
                    <span>이용 시간</span>
                  </v-col>
                  <v-col>
                    <span class="font-weight-bold">{{ reportsData ? $func.toFormatTime(reportsData.drivingTime) : 0 }}</span>
                  </v-col>
                  <v-col>
                    <span>총 운행 거리</span>
                  </v-col>
                  <v-col>
                    <span class="font-weight-bold">{{ noSearchResult ? "-" : $func.numberFormatter(reportsData.odoTotalDistances/1000) < 0 ? 0 : $func.numberFormatter(reportsData.odoTotalDistances/1000) }} km</span>
                  </v-col>
                  <v-col>
                    <span>총 탑승 거리</span>
                  </v-col>
                  <v-col>
                    <span class="font-weight-bold">{{ $func.numberFormatter(reportsData.totalBoardingDistances/1000) < 0 ? 0 : $func.numberFormatter(reportsData.totalBoardingDistances/1000) }} km</span>
                  </v-col>
                  <v-col>
                    <span>총 빈차 거리</span>
                  </v-col>
                  <v-col>
                    <span class="font-weight-bold">{{ noSearchResult ? "-" : (reportsData.odoTotalDistances - reportsData.totalBoardingDistances) < 0 ? 0 : $func.numberFormatter((reportsData.odoTotalDistances - reportsData.totalBoardingDistances)/1000) }} km</span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <div class="pa-4">
                <div class="subtitle-1 text-center font-weight-bold mb-3">회원 유형별 이용 현황</div>
                <v-row>
                  <v-col cols="5" class="text-center font-weight-bold statistic-table">회원 유형</v-col>
                  <v-col class="text-center font-weight-bold statistic-table__right">탑승 인원(명)</v-col>
                  <v-col class="text-center font-weight-bold statistic-table__right">이용자 수(명)</v-col>
                </v-row>
                <v-row v-for="type in userTypes" :key="type.key">
                  <v-col cols="5" class="text-center statistic-table__bottom">{{ type.text }}</v-col>
                  <v-col
                         v-for="usageType in usageTypes.filter(u => u.unit === '명')"
                         :key="usageType.key"
                         class="text-center statistic-table__bottom-right">
                    {{ customerType[usageType.key][type.key] || 0 }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-center statistic-table__bottom">합계</v-col>
                  <v-col
                         v-for="usageType in usageTypes.filter(u => u.unit === '명')"
                         :key="usageType.key"
                         class="text-center statistic-table__bottom-right"
                  >
                    {{ getTotalCountMapByUsageType(customerType, usageType) }}
                  </v-col>

                </v-row>
              </div>
            </v-col>
            <v-col cols="3">
              <div class="pa-4">
                <div class="subtitle-1 text-center font-weight-bold mb-3">용도별 이용 현황</div>
                <v-row>
                  <v-col cols="3" class="text-center font-weight-bold statistic-table">용도</v-col>
                  <v-col v-for="type in usageTypes" :key="type.key" class="text-center font-weight-bold statistic-table__right">
                    {{ type.text + "(" + type.unit + ")" }}
                  </v-col>
                </v-row>
                <v-row v-for="purpose in purposeTypes" :key="purpose">
                  <v-col cols="3" class="text-center statistic-table__bottom">{{ purpose }}</v-col>
                  <v-col v-for="type in usageTypes" :key="type.key" class="text-center statistic-table__bottom-right">
                    {{ (drivingUsage[purpose]) ? drivingUsage[purpose][type.key] : 0 }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="text-center statistic-table__bottom">합계</v-col>
                  <v-col v-for="type in usageTypes" :key="type.key" class="text-center statistic-table__bottom-right">
                    {{ getTotalCountByUsageType(drivingUsage, type) }}
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="3">
              <div class="pa-4">
                <div class="subtitle-1 text-center font-weight-bold mb-3">요금 현황</div>
                <v-row>
                  <v-col cols="7" class="text-center font-weight-bold statistic-table">요금</v-col>
                  <v-col cols="5" class="text-center font-weight-bold statistic-table__right">금액(원)</v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="text-center statistic-table__bottom">주행 요금</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.drivingFare) : 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="text-center statistic-table__bottom">대기 요금</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.waitFare) : 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="text-center statistic-table__bottom">도움서비스 요금</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.serviceFare) : 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="text-center statistic-table__bottom">추가 요금</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.extraFare) : 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="text-center statistic-table__bottom">할인 요금</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.discountFare) : 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="text-center statistic-table__bottom">배송 요금</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.deliveryFare) : 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="text-center statistic-table__bottom">총 요금</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.totalFare) : 0}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="text-center statistic-table__bottom">실 결제요금</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.realFare) : 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="text-center statistic-table__bottom">미수금</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">
                    <v-btn text color="red" @click="getUnpaidData">{{ reportsData ? $func.numberFormatter(reportsData.unpaidFare) : 0 }}</v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="3">
              <div class="pa-4">
                <div class="subtitle-1 text-center font-weight-bold mb-3">결제수단별 요금 현황</div>
                <v-row>
                  <v-col class="text-center font-weight-bold statistic-table">결제수단</v-col>
                  <v-col cols="5" class="text-center font-weight-bold statistic-table__right">금액(원)</v-col>
                  <v-col class="text-center font-weight-bold statistic-table__right">주행 건수(건)</v-col>
                  <v-col class="text-center font-weight-bold statistic-table__right">이용 건수(건)</v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center statistic-table__bottom">현금</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.payWithCash) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.payWithCashCount) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.usingCountWithCash) : 0}}</v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center statistic-table__bottom">카드</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.payWithCard) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.payWithCardCount) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.usingCountWithCard) : 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center statistic-table__bottom">합계</v-col>
                  <v-col cols="5" class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.payWithAll) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.payWithAllCount) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.usingCountWithCard + reportsData.usingCountWithCash) : 0 }}</v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <div class="pa-4">
                <div class="subtitle-1 text-center font-weight-bold mb-3">장애 유형별 이용 현황</div>
                <v-row>
                  <v-col cols="5" class="text-center font-weight-bold statistic-table">장애 유형</v-col>
                  <v-col class="text-center font-weight-bold statistic-table__right">탑승 인원(명)</v-col>
                  <v-col class="text-center font-weight-bold statistic-table__right">이용자 수(명)</v-col>
                </v-row>
                <v-row v-for="type in disabilityTypes1" :key="type.key">
                  <v-col cols="5" class="text-center statistic-table__bottom">{{ type.text }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ disabilityUsersByType[type.key] || 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ disabilityUsageByType[type.key] || 0 }}</v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="3">
              <div class="pt-11 px-4">
                <div class="subtitle-1 text-center font-weight-bold mb-3"> </div>
                <v-row>
                  <v-col cols="5" class="text-center font-weight-bold statistic-table">장애 유형</v-col>
                  <v-col class="text-center font-weight-bold statistic-table__right">탑승 인원(명)</v-col>
                  <v-col class="text-center font-weight-bold statistic-table__right">이용자 수(명)</v-col>
                </v-row>
                <v-row v-for="type in disabilityTypes2" :key="type.key">
                  <v-col cols="5" class="text-center statistic-table__bottom">{{ type.text }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ disabilityUsersByType2[type.key] || 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ disabilityUsageByType2[type.key] || 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-center statistic-table__bottom">합계</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ getTotalMapValueSum(disabilityUsersByType, disabilityUsersByType2)}}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ getTotalMapValueSum(disabilityUsageByType, disabilityUsageByType2)}}</v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="3">
              <div class="pa-4">
                <div class="subtitle-1 text-center font-weight-bold mb-3">장애 정도별 이용 현황</div>
                <v-row>
                  <v-col cols="5" class="text-center font-weight-bold statistic-table">장애 정도</v-col>
                  <v-col class="text-center font-weight-bold statistic-table__right">탑승 인원(명)</v-col>
                  <v-col class="text-center font-weight-bold statistic-table__right">이용자 수(명)</v-col>
                </v-row>
                <v-row v-for="degree in disabilityDegreeTypes" :key="degree.key">
                  <v-col cols="5" class="text-center statistic-table__bottom">{{ degree.text }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ disabilityUsersByDegree[degree.key] || 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ disabilityUsageByDegree[degree.key] || 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="text-center statistic-table__bottom">합계</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ getTotalMapValue(disabilityUsersByDegree)}}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ getTotalMapValue(disabilityUsageByDegree)}}</v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="3">
              <div class="pa-4">
                <div class="subtitle-1 text-center font-weight-bold mb-3">도움서비스별 이용 현황</div>
                <v-row>
                  <v-col cols="3" class="text-center font-weight-bold statistic-table">용도</v-col>
                  <v-col
                         v-for="type in usageTypes"
                         :key="type.key"
                         class="text-center font-weight-bold statistic-table__right">
                    {{ type.text + "(" + type.unit + ")" }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="text-center statistic-table__bottom">도움서비스</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.helpServiceTimes) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.helpServiceCustomers) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.helpServiceUsingCnt) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.helpServiceUserCnt) : 0 }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="text-center statistic-table__bottom">합계</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.helpServiceTimes) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.helpServiceCustomers) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.helpServiceUsingCnt) : 0 }}</v-col>
                  <v-col class="text-center statistic-table__bottom-right">{{ reportsData ? $func.numberFormatter(reportsData.helpServiceUserCnt) : 0 }}</v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <daily-reports-detail
              :start-date="searchDates[0]"
              :end-date="searchDates[1]"
              :table-mode="tableMode"
              :tables="tables"
              :keyword="keyword"
              :only-unpaid="onlyUnpaid"
              :download-excel-dialog.sync="downloadExcelDialog"
              :download-data-dialog.sync="downloadDataDialog"
              :loading.sync="loading"
              ref="dailyReportsDetail"
          ></daily-reports-detail>
        </v-card>
      </template>
    </contents-layout>
  </v-container>
</template>

<script>
import DailyReportsDetail from "@/views/CallTaxi/monitoring/DailyReportsDetail";
export default {
  components: {DailyReportsDetail},
  data() {
    return {
      loading: false,
      addDriverDialog: false, //이부분
      usageTypes: [
        { key: "주행건수", text: "주행 건수", unit: "건" },
        { key: "탑승인원", text: "탑승 인원", unit: "명" },
        { key: "이용건수", text: "이용 건수", unit: "건" },
        { key: "이용자수", text: "이용자 수", unit: "명" },
      ],
      userTypes: [
        {key: "일반", text: "일반"},
        {key: "장애인", text: "교통약자(장애인)"},
        {key: "영유아 가정", text: "교통약자(영유아 동반자)"},
        {key: "임산부", text: "교통약자(임산부)"},
        {key: "영유아", text: "교통약자(어린이)"},
        {key: "고령자", text: "교통약자(고령자)"},
        {key: "보호자", text: "보호자"},
      ],
      disabilityTypeKeys: ['간', '뇌전증', '뇌병변', '시각', '신장', '심장', '안면', '언어', '자폐성'],
      disabilityTypeKeys2: ['장루,요루', '정신', '지적', '지체', '청각', '호흡기', '일시적장애', '기타'],
      disabilityTypes1: [
        {key: '간', text:'간'},
        {key: '뇌전증', text:'뇌전증'},
        {key: '뇌병변', text:'뇌병변'},
        {key: '시각', text:'시각'},
        {key: '신장', text:'신장'},
        {key: '심장', text:'심장'},
        {key: '안면', text:'안면'},
        {key: '언어', text:'언어'},
        {key: '자폐성', text:'자폐성'},
      ],
      disabilityTypes2: [
        {key: '장루,요루', text:'장루, 요루'},
        {key: '정신', text:'정신'},
        {key: '지적', text:'지적'},
        {key: '지체', text:'지체'},
        {key: '청각', text:'청각'},
        {key: '호흡기', text:'호흡기'},
        {key: '일시적장애', text:'일시적 장애'},
        {key: '기타', text:'기타'}
      ],
      disabilityDegreeKeys: ['심함', '심하지않음', '기타'],
      disabilityDegreeTypes: [
        {key: '심함', text:'심함'},
        {key: '심하지않음', text:'심하지 않음'},
        {key: '기타', text:'기타'},
      ],
      startMenu: false,
      endMenu: false,
      tableMenu: false,
      tableMode: 1,
      searchDates: [this.$moment().subtract(1, 'months').format('YYYY-MM-DD'), this.$func.curDateString()],
      tables: [
        {no:1, name: "차량운행일보"},
        {no:2, name: "수입일지"}
      ],

      reportsData: null,
      drivingUsage: null,
      customerType: {},
      disabilityType: {},
      disabilityTypeUsage: {},
      disabilityDegree: {},
      disabilityDegreeUsage: {},
      usageList: [],

      purposeTypes: this.$store.state.centerInfo.useList.split(','),
      downloadDataDialog: false,
      downloadExcelDialog: false,
      keyword: '',
      onlyUnpaid: false,
    }
  },
  mounted() {
    this.reqDailyReports();
  },
  watch: {
    searchDates() {
      this.reqDailyReports();
    },
  },
  computed: {
    searchDateRangeDisplay() {
      return this.searchDates.join(' ~ ')
    },
    disabilityUsersByType() { // 탑승인원
      return Object.keys(this.disabilityType).reduce((acc, disabilityKey) => {
        if (this.disabilityTypeKeys.includes(disabilityKey)) {
          // 사용하는 장애 타입인 경우
          acc[disabilityKey] = this.disabilityType[disabilityKey]
        }
        return acc;
      }, {'간': 0, '뇌전증': 0, '뇌병변': 0, '시각': 0, '신장': 0, '심장': 0, '안면': 0, '언어': 0, '자폐성': 0});
    },
    disabilityUsageByType() { // 이용자수
      return Object.keys(this.disabilityTypeUsage).reduce((acc, disabilityKey) => {
        if (this.disabilityTypeKeys.includes(disabilityKey)) {
          // 사용하는 장애 타입인 경우
          acc[disabilityKey] = this.disabilityTypeUsage[disabilityKey]
        }
        return acc;
      }, {'간': 0, '뇌전증': 0, '뇌병변': 0, '시각': 0, '신장': 0, '심장': 0, '안면': 0, '언어': 0, '자폐성': 0});
    },
    disabilityUsersByType2() { // 탑승인원2
      return Object.keys(this.disabilityType).reduce((acc, disabilityKey) => {
        if (this.disabilityTypeKeys2.includes(disabilityKey)) {
          // 사용하는 장애 타입인 경우
          acc[disabilityKey] = this.disabilityType[disabilityKey]
        }
        return acc;
      }, {'장루,요루': 0, '정신': 0, '지적': 0, '지체': 0, '청각': 0, '호흡기': 0, '일시적장애': 0, '기타': 0 });
    },
    disabilityUsageByType2() { // 이용자수2
      return Object.keys(this.disabilityTypeUsage).reduce((acc, disabilityKey) => {
        if (this.disabilityTypeKeys2.includes(disabilityKey)) {
          // 사용하는 장애 타입인 경우
          acc[disabilityKey] = this.disabilityTypeUsage[disabilityKey]
        }
        return acc;
      }, {'장루,요루': 0, '정신': 0, '지적': 0, '지체': 0, '청각': 0, '호흡기': 0, '일시적장애': 0, '기타': 0 });
    },
    disabilityUsersByDegree() {
      return Object.keys(this.disabilityDegree).reduce((acc, degree) => {
        if (this.disabilityDegreeKeys.includes(degree)) {
          acc[degree] = this.disabilityDegree[degree];
        } else {
          acc['기타'] += this.disabilityDegree[degree];
        }
        return acc;
      }, {'심함': 0, '심하지않음': 0, '기타': 0})
    },
    disabilityUsageByDegree() {
      return Object.keys(this.disabilityDegreeUsage).reduce((acc, degree) => {
        if (this.disabilityDegreeKeys.includes(degree)) {
          acc[degree] = this.disabilityDegreeUsage[degree];
        } else {
          acc['기타'] += this.disabilityDegreeUsage[degree];
        }
        return acc;
      }, {'심함': 0, '심하지않음': 0, '기타': 0})
    },
    noSearchResult(){
      return this.reportsData.odoTotalDistances==0 && this.reportsData.odoEmptyDistances==0;
    }
  },
  methods: {
    getTotalMapValueSum(map1, map2) {
      const val1 = Object.values(map1).reduce((acc, cur) => acc + cur, 0);
      const val2 = Object.values(map2).reduce((acc, cur) => acc + cur, 0);
      return val1+val2;
    },
    getDataByKeyword() {
      this.reqDailyReports();
      this.$refs.dailyReportsDetail.filterTableData();
    },
    getUnpaidData() {
      this.onlyUnpaid = !!!(this.onlyUnpaid);
      this.$refs.dailyReportsDetail.filterTableData();
    },
    async reqDailyReports() {
      try {
        const { data } = await this.$api.getDailyReportsData(this.searchDates[0], this.searchDates[1], this.keyword);
        this.reportsData = data;
        this.customerType = data.customerType;
        this.disabilityType = data.disabilityType;
        this.disabilityTypeUsage = data.userCntByType;
        this.disabilityDegree = data.disabilityDegree;
        this.disabilityDegreeUsage = data.userCntByDegree;
        this.drivingUsage =  data.drivingUsage;
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqDailyReports'});
      }
    },
    getTotalMapValue(map) {
      return Object.values(map).reduce((acc, cur) => acc + cur, 0);
    },

    getTotalCountInMapValue(map) {
      return Object.values(map).reduce((acc, cur) => acc + cur['건수'], 0);
    },

    getTotalCustomersInMapValue(map) {
      return Object.values(map).reduce((acc, cur) => acc + cur['인원'], 0);
    },
    getTotalCountMapByUsageType(map, type) {
      return Object.values(map[type.key]).reduce((acc, cur) => acc + cur, 0);
    },
    changeObjToList(obj) {
      let result = [];
      let count = 0;
      for (const [key, val] of Object.entries(obj)) {
        result.push({key: key, val: val});
        count += val;
      }
      result.push({key: "합계", val: count});
      return result;
    },
    changeObjToRowDataList(obj) {
      let result = [];
      let count = 0, customerCnt = 0;
      for (const [key, val] of Object.entries(obj)) {
        result.push({key: key, count: val.count, customerCnt: val.customerCnt});
        count += val.count;
        customerCnt += val.customerCnt;
      }
      result.push({key: "합계", count: count, customerCnt: customerCnt});
      return result;
    },
    getTotalCountByUsageType(obj, type) {
      return Object.values(obj).reduce((acc, cur) => acc + cur[type.key], 0);
    }
  },
}
</script>
<style scoped>
</style>
